<template>
  <div class="life-header" :class="{'clear-header': showClearHeader}">
    <div class="header-wrapper">
      <div class="logo-box">
        <!-- <img class="logo" src="~@/assets/images/logo.png" alt="logo"> -->
      </div>
      <div class="menu-box">
        <span
          :class="path.startsWith(item.path) ? 'activeItem' : ''"
          v-for="item in menuList"
          :key="item.path"
          @click="handleClickMenu(item.path)"
        >{{item.name}}</span>
        <div class="menu-account">
          <el-dropdown v-cloak v-if="loginInfo.uid" trigger="click" @command="handleCommand">
            <div class="avatar-wrapper">
              <img class="avatar" v-if="loginInfo.avatar" :src="loginInfo.avatar" alt="avatar">
              <DefaultAvatar v-else class="avatar" alt="avatar"></DefaultAvatar>
              <CrownIcon class="crown" v-cloak v-if="loginInfo.pro>0"></CrownIcon>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logOut">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <button v-cloak v-else class="btn-log-in" @click="handleLogIn()">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Menu } from '@/router';
import DefaultAvatar from '@/components/svgIcon/defaultAvatar.vue';
import CrownIcon from '@/components/svgIcon/crown.vue';

export default {
  name: 'life-header',
  components: {
    DefaultAvatar,
    CrownIcon
  },
  data () {
    return {
      scrollTop: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    loginInfo () {
      return this.$store.getters.getUserLoginInfo;
    },
    menuList () {
      return this.loginInfo?.uid ? Menu : Menu.slice(2);
    },
    path () {
      return this.$route.path;
    },
    showClearHeader () {
      if (this.scrollTop > 540) {
        return false
      }
      return this.$route.path === '/feature' || this.$route.path === '/price'
    }
  },
  methods: {
    handleClickMenu (value) {
      if (this.path === value) {
        // window.location.reload();
        return;
      }
      this.$router.push(value);
    },
    handleCommand (command) {
      switch (command) {
        case 'logOut':
          this.handleLogOut();
          break;
      }
    },
    handleLogOut () {
      this.$store.commit('clearUserLoginInfo');
      localStorage.removeItem('$$token');
      localStorage.removeItem('$$uid');
      this.$router.replace('/login')
    },
    handleLogIn () {
      this.$router.push('/login')
    },
    handleScroll (e) {
      this.scrollTop = document.documentElement.scrollTop
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/assets/styles/variable.less');

.life-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: @bg-color;
  height: 60px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  z-index: 10;
  min-width: 1000px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.clear-header {
    background: none;
    box-shadow: none;
    .logo-box {
      background: url(https://website.dislikeapp.com/journal-logo-dark.png) no-repeat center center;
      background-size: cover;
      opacity: 0.6;
    }
    .menu-box {
      color: #fff;
    }
  }

  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 900px;
    padding: 0;
  }

  .logo-box {
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    background: url(https://website.dislikeapp.com/journal-logo.png) no-repeat center center;
    background-size: cover;
  }
  .menu-box {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: @text-color;
    span {
      margin-right: 60px;
      height: 30px;
      line-height: 30px;
      opacity: 0.8;
      cursor: pointer;

      &.activeItem {
        border-bottom: 2px solid #FC5204;
        font-weight: bold;
        opacity: 1;
      }
    }
    .menu-account {
      display: flex;
      width: 80px;
      justify-content: flex-end;
    }
    .avatar-wrapper {
      position: relative;
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        vertical-align: middle;
        border: 2px solid #fff;
        background-color: #eee;
      }
      .crown {
        position: absolute;
        top: -10px;
        right: -15px;
      }
    }
    .btn-log-in {
      border: 0 none;
      border-radius: 5px;
      background-color: #FC5204;
      color: #fff;
      height: 30px;
      padding: 0 15px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
